import {Card} from '@mui/material';
import React from 'react';

import {AlertInfo} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {ConcludedAlertProps} from './types';

export function ConcludedAlert({text}: ConcludedAlertProps) {
	const {isMobile} = useMediaQueries();

	return (
		<Card sx={{borderRadius: 0, position: 'sticky', zIndex: 3, top: isMobile ? 64 : 80}}>
			<AlertInfo.Root severity="success" sx={{borderRadius: 0, pl: isMobile ? 2 : 3}}>
				<AlertInfo.Title title={text} sx={{mb: 0}} />
			</AlertInfo.Root>
		</Card>
	);
}
